import React, { useContext, useMemo } from 'react';
import { AnyType } from '@src/models/common';
import { BreakpointsContext } from '@src/providers/Breakpoints';
import { IPropsWrapperProps, ITranslate, TBeforePropsWrapper, TModuleWrapperProps } from './models';

/**
 * Компонент обертка для переопределения некоторых свойств компонента. Аналог BpWrapper`а, его доработанная версия
 * - возвращает нужный компонент в зависимости от брейкпоинта
 * - мапит переводы
 */
export function ModuleWrapper<T extends TModuleWrapperProps<false, ITranslate>>(
  { bp, defaultTranslate }: IPropsWrapperProps<T>,
  props: TBeforePropsWrapper<T, AnyType>,
) {
  const { breakpoint } = useContext(BreakpointsContext);

  const Component = useMemo(() => {
    return (breakpoint && bp[breakpoint]) || bp.DESKTOP;
  }, [breakpoint, bp]);

  const t = useMemo(() => {
    const propsT = props.t || {};
    return {
      ...defaultTranslate,
      ...propsT,
    } as ITranslate;
  }, [defaultTranslate, props.t]);

  return <Component {...props} t={t} />;
}
